import { useQueryParamHelper } from '@shared/core/queryString';

export const useSearchTermQueryParam = (): string | undefined => {
  const { getValueString } = useQueryParamHelper();
  return getValueString('s');
};
